/* global pannellum */

SU.virtualTourModal = function(id, panoramicUrl, yaw) {
    console.debug(`set up virtual tour ${id}`);

    const
        modal             = document.getElementById(`${id}-modal`),
        panorama          = document.getElementById(`${id}-panorama`),
        panLeftControl    = document.getElementById(`${id}-pan-left`),
        panUpControl      = document.getElementById(`${id}-pan-up`),
        panDownControl    = document.getElementById(`${id}-pan-down`),
        panRightControl   = document.getElementById(`${id}-pan-right`),
        zoomInControl     = document.getElementById(`${id}-zoom-in`),
        zoomOutControl    = document.getElementById(`${id}-zoom-out`),
        fullScreenControl = document.getElementById(`${id}-full-screen`),
        step = 10;

    var viewer;

    modal.addEventListener('shown.bs.modal', initialise);
    modal.addEventListener('hidden.bs.modal', destroy);

    function initialise() {
        console.debug(`Initialising tour ${id}`);

        const options = {
            type: 'equirectangular',
            panorama: panoramicUrl,
            autoLoad: true,
            hfov: 10000,
            showControls: false
        };

        if (isNumeric(yaw)) {
            options.yaw = parseInt(yaw, 10);
        }

        viewer = pannellum.viewer(`${id}-panorama`, options);

        panLeftControl.addEventListener('click', panLeftClickHandler);
        panLeftControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        panLeftControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        panUpControl.addEventListener('click', panUpClickHandler);
        panUpControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        panUpControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        panDownControl.addEventListener('click', panDownClickHandler);
        panDownControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        panDownControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        panRightControl.addEventListener('click', panRightClickHandler);
        panRightControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        panRightControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        zoomInControl.addEventListener('click', zoomInClickHandler);
        zoomInControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        zoomInControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        zoomOutControl.addEventListener('click', zoomOutClickHandler);
        zoomOutControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        zoomOutControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        viewer.on('zoomchange', maybeEnableOrDisableZoomControls);

        fullScreenControl.addEventListener('click', fullScreenClickHandler);
        fullScreenControl.addEventListener('keyup', anyControlKeyUpOrDownHandler);
        fullScreenControl.addEventListener('keydown', anyControlKeyUpOrDownHandler);

        viewer.on('fullscreenchange', fullscreenChangeHander);

        console.debug('done');
    }

    function isNumeric(text) {
        return typeof text === 'string' && text.trim() !== '' && !isNaN(Number(text));
    }

    function panLeftClickHandler() {
        viewer.setYaw(viewer.getYaw() - step);
    }

    function anyControlKeyUpOrDownHandler(event) {
        if (event.shiftKey) {
            // <SHIFT> will zoom in if allowed to propagate, which hurts <SHIFT-TAB>
            event.stopPropagation();
        }
    }

    function panUpClickHandler() {
        viewer.setPitch(viewer.getPitch() + step);
    }

    function panDownClickHandler() {
        viewer.setPitch(viewer.getPitch() - step);
    }

    function panRightClickHandler() {
        viewer.setYaw(viewer.getYaw() + step);
    }

    function zoomInClickHandler() {
        viewer.setHfov(viewer.getHfov() - step);
    }

    function zoomOutClickHandler() {
        viewer.setHfov(viewer.getHfov() + step);
    }

    function maybeEnableOrDisableZoomControls() {
        if (!canZoomIn()) {
            zoomInControl.setAttribute('disabled', true);
        } else {
            zoomInControl.removeAttribute('disabled');
        }

        if (!canZoomOut()) {
            zoomOutControl.setAttribute('disabled', true);
        } else {
            zoomOutControl.removeAttribute('disabled');
        }
    }

    function canZoomIn() {
        const
            hfov       = Math.round(viewer.getHfov()),
            hfovBounds = viewer.getHfovBounds(),
            minHfov    = hfovBounds[0],
            canZoomIn  = hfov > minHfov;
        return canZoomIn;
    }

    function canZoomOut() {
        const
            hfov       = Math.round(viewer.getHfov()),
            hfovBounds = viewer.getHfovBounds(),
            maxHfov    = hfovBounds[1],
            canZoomOut = hfov < maxHfov;
        return canZoomOut;
    }

    function fullScreenClickHandler() {
        viewer.toggleFullscreen();
    }

    function fullscreenChangeHander() {
        const icon = fullScreenControl.firstElementChild;
        icon.classList.toggle('fa-up-right-and-down-left-from-center');
        icon.classList.toggle('fa-down-left-and-up-right-to-center');
    }

    function destroy() {
        console.debug(`Destroying tour ${id}`);

        const controls = document.getElementById(`${id}-controls`);
        modal.appendChild(controls); // preserve controls by moving them before viewer is destoyed
        viewer.destroy();
        panorama.prepend(controls); // put controls back where they belong

        panLeftControl.removeEventListener('click', panLeftClickHandler);
        panLeftControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        panLeftControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        panUpControl.removeEventListener('click', panUpClickHandler);
        panUpControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        panUpControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        panDownControl.removeEventListener('click', panDownClickHandler);
        panDownControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        panDownControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        panRightControl.removeEventListener('click', panRightClickHandler);
        panRightControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        panRightControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        zoomInControl.removeEventListener('click', zoomInClickHandler);
        zoomInControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        zoomInControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        zoomOutControl.removeEventListener('click', zoomOutClickHandler);
        zoomOutControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        zoomOutControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        viewer.off('zoomchange', maybeEnableOrDisableZoomControls);

        fullScreenControl.removeEventListener('click', fullScreenClickHandler);
        fullScreenControl.removeEventListener('keyup', anyControlKeyUpOrDownHandler);
        fullScreenControl.removeEventListener('keydown', anyControlKeyUpOrDownHandler);

        viewer.off('fullscreenchange', fullscreenChangeHander);

        console.debug('done');
    }
};
